;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { TOUR_OVERLAY_GROUPS } from "@/features/onboarding-tours/orchestrator/tour-overlay-groups";
import { tourStep } from "@/features/onboarding-tours/orchestrator/tour-step-builder";
import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { defineTour } from "@/features/onboarding-tours/registry/define-tour";
import { TourCategory } from "@/features/onboarding-tours/types/tour-category";

const invitePermissionsTarget = tourSelector(
	TOUR_TARGETS.invitePermissionsSection,
);
const sidebarUserMenuTriggerTarget = tourSelector(
	TOUR_TARGETS.sidebarUserMenuTrigger,
);

export const inviteTeamMemberTour = defineTour({
	buildSteps: () => [
		tourStep({
			blockTargetInteraction: false,
			content:
				"Open the invite panel to add colleagues and assign their workspace access.",
			data: {
				advanceOn: "target-click",
			},
			placement: "left",
			scrollBefore: tourSelector(TOUR_TARGETS.workspaceMembersSection),
			spotlightPadding: 12,
			target: tourSelector(TOUR_TARGETS.inviteMemberButton),
			title: "Invite a team member",
		}),
		tourStep({
			content:
				"Enter an email address, choose a role, then click the plus button to add them to the invite list.",
			data: {
				advanceOn: "target-visible",
				advanceWhenTarget: invitePermissionsTarget,
				overlayGroup: TOUR_OVERLAY_GROUPS.inviteSheet,
				skipNextStepWhenHidden: invitePermissionsTarget,
			},
			effect: "openInviteMembers",
			hideOverlay: true,
			placement: "left",
			target: tourSelector(TOUR_TARGETS.inviteEmailSection),
			title: "Add an email",
			waitForTarget: true,
		}),
		tourStep({
			content:
				"Adjust the permissions this person will have when they join the workspace.",
			data: {
				advanceOn: "none",
				advanceWhenTarget: invitePermissionsTarget,
				overlayGroup: TOUR_OVERLAY_GROUPS.inviteSheet,
				skipWhenTargetHidden: true,
			},
			effect: "openInviteMembers",
			hideOverlay: true,
			placement: "left",
			target: invitePermissionsTarget,
			title: "Set permissions",
		}),
		tourStep({
			content: "Send the invitation when you are ready, or cancel to close.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.inviteSheet,
			},
			effect: "openInviteMembers",
			hideOverlay: true,
			placement: "top",
			target: tourSelector(TOUR_TARGETS.inviteSendButton),
			title: "Send invitations",
			waitForTarget: true,
		}),
	],
	catalog: {},
	category: TourCategory.workspaceTeam,
	description: "Add colleagues to your workspace and assign their permissions.",
	eligibility: { requiresInvitePermission: true },
	id: "invite-team-member",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/settings?tab=workspace`,
	},
	tags: ["invite", "team", "members", "users"],
	title: "Invite a team member",
});

export const workspaceNavigationTour = defineTour({
	buildSteps: () => [
		tourStep({
			content: "Expand or collapse the navigation sidebar.",
			placement: "right",
			target: tourSelector(TOUR_TARGETS.sidebarTrigger),
			title: "Sidebar",
		}),
		tourStep({
			content:
				"Open leaderboard, leasing, and your other enabled dashboard views from here.",
			placement: "right",
			spotlightPadding: 12,
			target: tourSelector(TOUR_TARGETS.sidebarWorkspaceNav),
			title: "Dashboard views",
		}),
		tourStep({
			content: "Click your avatar to open settings or sign out.",
			placement: "right",
			spotlightPadding: 8,
			target: sidebarUserMenuTriggerTarget,
			title: "Settings and logout",
		}),
	],
	catalog: {},
	category: TourCategory.workspaceTeam,
	description:
		"Learn to collapse the sidebar, switch dashboard views, and find settings and logout.",
	eligibility: {},
	id: "workspace-navigation",
	launch: {
		startOnCurrentPage: true,
	},
	tags: ["navigation", "sidebar", "workspace", "orientation"],
	title: "Navigate your workspace",
});
